import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Intro from './pages/Intro/Intro';
import Test from "./pages/Test/Test"
import Result from './pages/Result/Result'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Intro />} />
        <Route path="/test/:time" element={<Test />} />
        <Route path="/result/" element={<Result />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
